import moment from 'moment-timezone';

import { EventsFilter } from '../../interfaces';
import { RefreshTrigger } from '../../interfaces/refreshTrigger';

export interface EventFiltersState {
  filter: EventsFilter;
  collapseTrigger: Object;
  refreshSignal: RefreshTrigger;
}

export const initialEventFiltersState: EventFiltersState = {
  filter: {
    // Events filtering default setting for the Slider,
    // Defines from how many hours from the past the Events should be
    // fetched.
    dateFrom: moment().subtract(1, 'week').startOf('day').toISOString(),
    dateTo: moment().toISOString(),

    // Selected tags for filtering, their identifiers
    selectedFilters: [],

    // Selected license plates
    license_plates: [],

    time_of_day: [0, 24],

    vehicle_types: [],
    active_lanes: [],

    route_ids: [],
    vehicle_ids: [],
    location_ids: [],
    bus_stop_ids: [],
    device_ids: [],
  } as const,
  collapseTrigger: {},

  // just change the pointer on this to trigger background update on list.
  // same effect as using observables, basically
  refreshSignal: {
    eventId: undefined,
  },
};
